import styled, { css } from 'styled-components';

import { wave } from './wave';

export interface AnimatedDotProps {
  delay?: number;
  fill: string;
  stroke: string;
  fillActive: string;
  strokeActive: string;
  d: string;
}

function getWaveKeyframes(colors: {
  fill: string;
  stroke: string;
  fillActive: string;
  strokeActive: string;
}) {
  return wave(colors);
}

export const ANIMATION_DURATION = 1.2;

const AnimatedDot = styled.path.attrs<AnimatedDotProps>(props => ({
  'aria-hidden': true,
  delay: props.delay,
  d: props.d,
}))<AnimatedDotProps>`
  transform-origin: center;
  fill: ${({ fill }) => fill};
  stroke: ${({ stroke }) => stroke};
  stroke-width: 0.2;
  ${({ fill, stroke, fillActive, strokeActive }) => {
    const keyframes = getWaveKeyframes({
      fill,
      stroke,
      fillActive,
      strokeActive,
    });
    return css`
      animation: ${keyframes} ${ANIMATION_DURATION}s infinite linear
        alternate-reverse;
    `;
  }}
  ${({ delay }) =>
    delay !== undefined &&
    css`
      animation-delay: ${delay}s;
    `}
`;

export default AnimatedDot;
